import React from 'react'
import { isLZWKAPP, judgeAPPVersion, renderMoney } from '../../../utils'
import { toChannel } from '../../../utils/connectApp'

class Item extends React.Component {

    handleLink(is_join, content) {
        if (this.props.isAppInvite) {
            return this.props.showToAppDialog()
        }
        const inviterId = this.props.inviterId
        if (isLZWKAPP()) {
            if (window.systemType === 'ios') {
                if (judgeAPPVersion(400)) {
                    return location.assign(`lizhiweike://channel?channel_id=${content.id}&inviter_id=${inviterId}&is_has_coupon=true`)
                }
            }
            if (window.systemType === 'android') {
                if (judgeAPPVersion(310)) {
                    return location.assign(`lizhiweike://channel?channel_id=${content.id}&inviter_id=${inviterId}`)
                }
            }
        }
        if (is_join) {
            window.location = `/channel/${content.id}?inviter_id=${inviterId}&auto_pay_use_wkcoupon=1`;
        } else {
            if (isLZWKAPP()){
                if (window.systemType === 'ios') {
                    location.assign(`lizhiweike://channel?channel_id=${content.id}&is_has_coupon=true`)
                } else {
                    toChannel(content.id);
                }
            }else {
                window.location.href = `/channel/${content.id}?inviter_id=${inviterId}`;
            }
        }
    }

    render() {
        const {price, is_join, content} = this.props;
        return (
            <div className={`list__item ${is_join ? '' : 'nojoin'}`} onClick={() => this.handleLink(is_join, content)}>
                <div className="item__img" style={{backgroundImage: `url(${content.cover_url})`}}>

                </div>
                <div className="item__title">
                    {content.name}
                </div>

                <div className="item_courer_tag">
                    {content.channel_tag}
                </div>
                {/*<div className="item__num">*/}
                    {/*<div>{content.popular}人在听</div>*/}
                    {/*<div style={{textDecoration: 'line-through'}}>￥{renderMoney(content.nominal_money)}</div>*/}
                {/*</div>*/}
                {/* <div className="item__money">
                    <div className="reduce" style={{backgroundImage: `url(${reduceImg})`}}>
                        减{(+price).toFixed(0)}元
                    </div>
                </div> */}
                <div className="lijian">
                    立减{(+content.coupon_price).toFixed(0)}元
                </div>

                {
                    is_join && (
                        <div className="item__bottom">
                            <button>立即抢购</button>
                            <img className="coupon-gif-bag" src="https://static-1253442168.image.myqcloud.com/picture/8173011_803336c73e091ac8e269b5dd4e875efe.jpg" alt=""/>
                        </div>
                    )
                }
            </div>
        )
    }
}

export default Item


// WEBPACK FOOTER //
// ./src/pages/ActivityPage/Coupon/CouponItemV7.js